export const C_TRANSACTION_EDIT_BUTTON = 7
export const C_TRANSACTION_NEW_BUTTON = 10
export const C_CLIENT_SEARCH = 11
export const C_CLIENT_DASHBOARD = 12
export const C_ADMIN_DASHBOARD = 13


